(ns shared.core.form
  (:require [shared.core.reactive :as re]))

(re/reg-event-db
  :form/change re/quiet-middleware
  (fn [db [form-path & args]]
    (update-in db form-path #(apply assoc % args))))

(re/reg-event-db
  :form/change-add-to-vec re/middleware
  (fn [db [form-path form-name concat-val]]
    (assoc-in db (conj form-path form-name) (-> (get-in db (conj form-path form-name) [])
                                                (concat (if (vector? concat-val)
                                                          concat-val
                                                          [concat-val]))
                                                (vec)))))

(re/reg-event-db
  :form/change-remove-from-vec re/middleware
  (fn [db [form-path form-name remove-val]]
    (assoc-in db (conj form-path form-name) (filterv #(if (vector? remove-val)
                                                        (not (get (into #{} remove-val) %))
                                                        (not= % remove-val))
                                                     (get-in db (conj form-path form-name) [])))))

(re/reg-event-db
  :form/init re/middleware
  (fn [db [form-path data]]
    (assoc-in db form-path data)))

(re/reg-event-db
  :form/reset re/middleware
  (fn [db [form-path]]
    (assoc-in db form-path nil)))

(re/reg-sub
  :form/val-
  (fn [db [_ form-path form-name]]
    (get-in db (conj form-path form-name))))

(re/reg-sub
  :form/form-
  (fn [db [_ form-path]]
    (get-in db form-path)))
